<div class="header">
    <div class="row">
        <div class="col-6">
            <h2>Modifica <strong>Fornitore</strong></h2>
        </div>
        <div class="col-4" style="text-align: right; margin-top: 10px;">
            <ol class="breadcrumb">
                <li><a style="cursor: pointer;" [routerLink]="['/fornitori']">Fornitori</a></li>
                <li class="active">Modifica Fornitore</li>
            </ol>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-lg-10 portlets" style="margin-bottom: 80px;">
        <div class="panel">
            <div class="panel-content" style="padding-top: 20px; padding-bottom: 20px;">
                <div *ngIf="supplier.IDSupplier !== undefined" class="row" style="margin-top: 30px; margin-bottom: 30px;">
                    <div class="col-sm-8 offset-sm-2">
                        <form #supplierForm="ngForm" role="form" class="form-horizontal form-validation">
                            <p class="section-supplier-data">Dati relativi al Fornitore</p>

                            <div class="form-group">
                                <label for="name" class="col-sm-3 control-label">Nome</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="name"
                                           name="name"
                                           class="form-control"
                                           placeholder="Inserisci nome del fornitore"
                                           autocomplete="off"
                                           [(ngModel)]="supplier.Name">
                                    <i class="icon-drawer"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="cf" class="col-sm-3 control-label">Codice Fiscale</label>
                                <div class="col-sm-9 field-column">
                                    <div class="prepend-icon">
                                        <input type="text"
                                               id="cf"
                                               name="cf"
                                               class="form-control"
                                               placeholder="Inserisci codice fiscale"
                                               autocomplete="off"
                                               [(ngModel)]="supplier.CF">
                                        <i class="icon-list"></i>
                                    </div>
                                    <mat-checkbox class="foreign-toggle" color="primary" name="foreign-supplier" [(ngModel)]="foreignSupplier">Fornitore estero</mat-checkbox>
                                    <span class="field-hint" *ngIf="!foreignSupplier">Formato italiano: 11 cifre per una società, 16 caratteri per una persona fisica.</span>
                                    <span class="field-hint" *ngIf="foreignSupplier">Inserisci l'identificativo fiscale del paese del fornitore.</span>
                                    <span class="field-error" *ngIf="cfError">{{ cfError }}</span>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="email-0" class="col-sm-3 control-label">Email</label>
                                <div class="col-sm-9 field-column">
                                    <div class="email-list-container">
                                        <div class="email-input-row" *ngFor="let email of emails; let i = index; trackBy: trackByIndex">
                                            <div class="prepend-icon email-input-wrapper">
                                                <input type="email"
                                                       [id]="'email-' + i"
                                                       [name]="'email-' + i"
                                                       class="form-control"
                                                       [class.input-error]="hasEmailItemError(i)"
                                                       [placeholder]="emails.length > 1 ? 'Inserisci indirizzo email ' + (i + 1) : 'Inserisci indirizzo email'"
                                                       autocomplete="off"
                                                       [(ngModel)]="emails[i]"
                                                       (ngModelChange)="onEmailChange(i, $event)">
                                                <i class="icon-envelope"></i>
                                            </div>
                                            <button type="button"
                                                    class="btn btn-sm btn-danger email-remove-btn"
                                                    (click)="removeEmail(i)"
                                                    [disabled]="emails.length === 1"
                                                    title="Rimuovi indirizzo email"
                                                    aria-label="Rimuovi indirizzo email">
                                                <i class="fa fa-trash-o"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="email-actions">
                                        <button type="button"
                                                class="btn btn-sm btn-default email-add-btn"
                                                (click)="addEmail()">
                                            <i class="fa fa-plus"></i> Aggiungi email
                                        </button>
                                    </div>
                                    <span class="field-hint">Usa il pulsante "Aggiungi email" per inserire più indirizzi per questo fornitore.</span>
                                    <span class="field-error" *ngIf="emailFieldError">{{ emailFieldError }}</span>
                                </div>
                            </div>
                        </form>

                        <div class="row" style="margin-top: 30px;">
                            <div class="col-sm-9 offset-sm-3 text-right">
                                <a class="btn btn-embossed btn-default" style="margin-right: 10px;"
                                   [routerLink]="['/fornitori']">Annulla</a>
                                <button type="button"
                                        class="btn btn-embossed btn-primary"
                                        (click)="saveAndGoToList()">Salva</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
